const emailRegex =
  // eslint-disable-next-line no-useless-escape
  /^(?!\.)(?!.*\.\.)([A-Z0-9_+-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i;

export function validateEmail(input?: string): boolean {
  if (!input) {
    return false;
  }

  return !!input.match(emailRegex);
}
